import { Button } from '../ui/button';
import { MapPin, ArrowLeft } from 'lucide-react';

export const HeroSection = ({ tripInput, dynamicDestImages, destinationImages, onBack }) => (
  <div className="relative h-72 md:h-96 overflow-hidden" data-testid="hero-section">
    <img
      src={dynamicDestImages[0] || destinationImages[0]}
      alt={`${tripInput.destination_cities?.length > 1 ? tripInput.destination_cities.join(', ') : tripInput.destination_city}, ${tripInput.destination_country}`}
      className="w-full h-full object-cover"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-forest/90 via-forest/50 to-transparent" />
    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-12 lg:p-24">
      <Button
        variant="ghost"
        onClick={onBack}
        className="mb-4 text-sand/80 hover:text-sand hover:bg-white/10"
        data-testid="back-to-dashboard"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Dashboard
      </Button>
      <h1 className="font-serif text-3xl md:text-5xl text-sand mb-2">
        {tripInput.destination_cities?.length > 1
          ? tripInput.destination_cities.join(' \u2192 ')
          : tripInput.destination_city}
      </h1>
      <p className="text-sand/80 text-lg flex items-center gap-2">
        <MapPin className="w-5 h-5" />
        {tripInput.destination_country}
        {tripInput.destination_cities?.length > 1 && (
          <span className="ml-2 bg-gold/20 text-gold px-3 py-1 rounded-full text-sm">
            Multi-City Trip
          </span>
        )}
      </p>
    </div>
  </div>
);
